document.addEventListener("DOMContentLoaded", function () {
	const nav = document.querySelector(".legals-context-nav");

	if (!nav) {
		return;
	}

	const links = nav.querySelectorAll("a[href^='#']");
	const sections = [];

	links.forEach(function (link) {
		const id = link.getAttribute("href").substring(1);
		const section = document.getElementById(id);
		if (section) {
			sections.push({ el: section, link: link });
		}
	});

	if (!sections.length) {
		return;
	}

	const observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				const match = sections.find(function (s) {
					return s.el === entry.target;
				});

				if (!match) {
					return;
				}

				if (entry.isIntersecting) {
					links.forEach(function (l) {
						l.classList.remove("active");
					});
					match.link.classList.add("active");
				}
			});
		},
		{
			rootMargin: "-20% 0px -60% 0px",
		}
	);

	sections.forEach(function (s) {
		observer.observe(s.el);
	});
});
